import { render, staticRenderFns } from "./CommentThread.vue?vue&type=template&id=db938a1c&scoped=true"
import script from "./CommentThread.vue?vue&type=script&lang=js"
export * from "./CommentThread.vue?vue&type=script&lang=js"
import style0 from "./CommentThread.vue?vue&type=style&index=0&id=db938a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db938a1c",
  null
  
)

export default component.exports